import type { LogoWithUrl, StoredThemeColors } from 'src/model/v2/interface/props'
import { REQUIRED_MSG, MAX_FILE_SIZE_BYTES, FILE_TOO_LARGE_MSG, THEME_COLORS_STORAGE_KEY } from 'src/model/v2/interface/constants'

export const makeFieldError = (submitAttempted: boolean, hasError: boolean) =>
    submitAttempted && hasError ? REQUIRED_MSG : undefined

export const makePhoneFieldError = (submitAttempted: boolean, phone: string) =>
    submitAttempted && !phone ? REQUIRED_MSG : undefined

export const isFormValid = (errors: Record<string, boolean>) =>
    Object.values(errors).every((hasError) => !hasError)

export const handleLogoSelect = (
    setLogo: (file: LogoWithUrl | null) => void,
    setError: (msg: string | undefined) => void,
) => (file: File) => {
    if (file.size > MAX_FILE_SIZE_BYTES) {
        setError(FILE_TOO_LARGE_MSG)
        return
    }
    setError(undefined)
    setLogo({ name: file.name, size: `${Math.round(file.size / 1024)} KB`, file })
}

export const handleLogoRemove = (
    setLogo: (file: LogoWithUrl | null) => void,
    setError: (msg: string | undefined) => void,
) => () => {
    setLogo(null)
    setError(undefined)
}

export const loadStoredColors = (): StoredThemeColors | null => {
    try {
        const raw = window.localStorage.getItem(THEME_COLORS_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}
